  <template>
    <v-container>
      <v-card class="mx-auto" outlined>
        <v-card-title
          style="font-size: 18px; font-weight: 700; color: rgb(50,134,218); align-self:center;text-align:center;justify-content:center;">设备巡检记录</v-card-title>
        <v-text-subtitle class="ml-4" style="color:rgb(132, 132, 132); font-size: 12px;">根据消防点检情况进行填写</v-text-subtitle>
        <v-form ref="form" v-model="isValid">
          <v-card-text>
            <v-row>
              <!-- 设备名称 -->
              <v-col cols="12" style="border: 1px rgb(188,188,189) solid;">
                <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备类型 <p
                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                <v-text-field v-model="formData.deviceName" label="请输入设备名称" :rules="requiredRules" required
                  hint="请输入设备名称"></v-text-field>
              </v-col>

              <!-- 设备结果 -->
              <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid;">
                <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备状态 <p
                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                <v-radio-group v-model="formData.deviceResult" :rules="requiredRules" required column>
                  <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 20px;" label="正常"
                    value="normal"></v-radio>
                  <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 20px;" label="异常"
                    value="abnormal"></v-radio>
                </v-radio-group>
              </v-col>

              <!-- 设备数 -->
              <v-col cols="12" style="border: 1px rgb(188,188,189) solid;" class="mt-1">
                <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备数量 <p
                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                <v-text-field v-model="formData.deviceCount" label="请输入巡检设备数" type="number" :rules="countRules" required
                  hint="请输入同一类型设备点检数量"></v-text-field>
              </v-col>

              <!-- 设备描述 -->
              <v-col cols="12" style="border: 1px rgb(188,188,189) solid;" class="mt-1">
                <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">详情描述 <p
                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                <v-textarea v-model="formData.description" label="点检异常补充说明" :rules="requiredRules" required
                  hint="请输入设备描述"></v-textarea>
              </v-col>

              <!-- 附件上传 -->
              <v-col cols="12" style="border: 1px rgb(188,188,189) solid;" class="mt-1">
                <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">附件</v-text-subtitle>
                <v-file-input v-model="formData.attachment" label="附件" accept="image/*, .pdf, .doc, .docx" required
                  hint="支持上传图片、PDF、Word文档"></v-file-input>
              </v-col>

              <v-card-title style="font-size: 18px; font-weight: 700; color: rgb(50,134,218);">巡检人员信息</v-card-title>

              <!-- 巡检人 -->
              <v-col cols="12" style="border: 1px rgb(188,188,189) solid;" class="mt-1">
                <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">巡检人员 <p
                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                <v-text-field v-model="formData.inspector" label="请输入巡检人名称" :rules="requiredRules" required
                  hint="请输入巡检人名称"></v-text-field>
              </v-col>

              <!-- 巡检部门 -->
              <v-col cols="12" style="border: 1px rgb(188,188,189) solid;" class="mt-1">
                <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">巡检部门 <p
                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                <v-text-field v-model="formData.department" label="请输入巡检部门/组" :rules="requiredRules" required
                  hint="请输入巡检部门/组"></v-text-field>
              </v-col>

              <!-- 巡检时间 -->
              <v-col cols="12" style="border: 1px rgb(188,188,189) solid;" class="mt-1">
                <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">巡检时间 <p
                    style="color: red; display: inline-block;">*</p></v-text-subtitle>
                <v-text-field v-model="formData.inspectionTime" label="" readonly hint="自动填充当前时间"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-space-around">
            <!-- <v-spacer></v-spacer>   -->
            <v-btn color="blue darken-1" dark @click="submitForm">提交</v-btn>
            <v-btn color="success" dark @click="resetForm">重置</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </template>

<script>
export default {
  name: 'abnormal',
  data() {
    return {
      isValid: false,
      formData: {
        deviceName: '',
        deviceResult: '',
        deviceCount: '',
        description: '',
        attachment: null,
        inspector: '',
        department: '',
        inspectionTime: ''
      },
      requiredRules: [v => !!v || '该字段是必填项'],
      countRules: [v => !!v || '该字段是必填项', v => /^\d+$/.test(v) || '请输入有效的数字']
    }
  },
  mounted() {
    this.formData.inspectionTime = new Date().toLocaleString()
  },
  methods: {
    submitForm() {
      this.$refs.form.validate()
      if (this.isValid) {
        console.log('表单输入数据', this.formData)
        this.$axios.post('').then(response => {
          this.$router.push("/logo")
          console.log('响应数据:', response.data)
        }).catch(error => {
          console.error('请求失败:', error)
        })
      }
    },
    resetForm() {
      this.$refs.form.reset()
      this.formData.inspectionTime = new Date().toLocaleString()
      alert("确认进行重置!");
    }
  }

}

</script> 